import React from "react";
import { Rings } from "react-loading-icons";

export default function Loading() {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: "#222020",
        opacity: 0.8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "3000",
      }}
    >
      <Rings style={{ width: "150px", height: "150px" }} />
    </div>
  );
}
